import Money, { MoneyJSON } from "common/values/money/money";

export interface FeeJSON {
  rate: MoneyJSON,
  unit: string | null;
}

export default class Fee {
  rate: Money;
  unit: string | null;

  constructor(rate: Money, unit: string | null) {
    this.rate = rate;
    this.unit = unit;
  }

  public isEqualTo(other: Fee | null): boolean {
    if (!other) return false;
    return (
      ((!this.rate && !other.rate) || !!this.rate?.isEqualTo(other.rate)) &&
      (this.unit === other.unit)
    );
  }

  public clone(): Fee {
    return new Fee(this.rate?.clone(), this.unit);
  }

  public static fromJSON(json: FeeJSON): Fee {
    if (!json) return json;
    return new Fee(
      Money.Prototype.fromJSON(json.rate),
      json.unit,
    );
  }

  public fromJSON(json: FeeJSON): Fee {
    return Fee.fromJSON(json);
  }

  public toJSON(): FeeJSON {
    return {
      rate: this.rate?.toJSON(),
      unit: this.unit
    };
  }

  public static get Prototype(): Fee {
    return new Fee(Money.Prototype, '');
  }

  public toString(): string {
    if (!this.rate) return '';
    return `${this.rate?.amount?.toString()} ${this.rate?.currency?.toString()} ${this.unit ? '/ ' + this.unit : 'fixed'}`;
  }
}
